module.exports = __webpack_public_path__ + "bee85bbaae0447109bd8e048f0ef58d9.png";